export const ariaAttr = (condition) => condition ? true : undefined;
